module.exports = __webpack_public_path__ + "p6_img4.jpg?2d614e41b663821448c6a7bd2ee145fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img4.jpg
// module id = 124
// module chunks = 0